import React from 'react'
import { observer } from 'mobx-react-lite'

import { StoreTableHasMsProductFilterBase } from './StoreTableHasMsProductFilterBase'

import { ServerTableData } from '../store/serverTableData'

import { StoreProductsTableFilterColumn } from '../server/mpsklad_core/Models/StoreProductsTableFilterColumn'

export type StoreTableHasMsProductFilterProps<TRow extends object, TColumnId extends string> = {
  products: ServerTableData<TRow, TColumnId, typeof StoreProductsTableFilterColumn, never>
}

export const StoreTableHasMsProductFilter =
  observer(
    <TRow extends object, TColumnId extends string>
    ({products}: StoreTableHasMsProductFilterProps<TRow, TColumnId>) =>
      <StoreTableHasMsProductFilterBase
        value={products.findPropFilterValue('hasMsProduct')}
        setValue={_ => products.setPropFilter('hasMsProduct', _)}
        readOnly={products.getPropFilterReadOnly('hasMsProduct')}
      />)